/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type LinkedInChatListItemConnectionState = typeof LinkedInChatListItemConnectionState[keyof typeof LinkedInChatListItemConnectionState];


export const LinkedInChatListItemConnectionState = {
  connected: 'connected',
  pending_invite: 'pending_invite',
  not_connected: 'not_connected',
} as const;
